"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _tinymce = _interopRequireDefault(require("tinymce"));

// Ported from https://github.com/tinymce/tinymce/blob/4.9.2/src/ui/main/ts/NotificationManagerImpl.ts
var Notification = _tinymce.default.ui.Notification;

function _default(editor) {
  var getEditorContainer = function getEditorContainer(ed) {
    return ed.inline ? ed.getElement() : ed.getContentAreaContainer();
  };

  var getContainerWidth = function getContainerWidth() {
    var container = getEditorContainer(editor);
    return editor.dom.getSize(container).width;
  }; // Since the viewport will change based on the present notifications, we need to move them all to the
  // top left of the viewport to give an accurate size measurement so we can position them later.


  var prePositionNotifications = function prePositionNotifications(notifications) {
    notifications.forEach(function (notification) {
      notification.moveTo(0, 0);
    });
  };

  var positionNotifications = function positionNotifications(notifications) {
    if (notifications.length > 0) {
      var firstItem = notifications.slice(0, 1)[0];
      var container = getEditorContainer(editor);
      firstItem.moveRel(container, 'tc-tc');
      notifications.forEach(function (notification, index) {
        if (index > 0) {
          notification.moveRel(notifications[index - 1].getEl(), 'bc-tc');
        }
      });
    }
  };

  var reposition = function reposition(notifications) {
    prePositionNotifications(notifications);
    positionNotifications(notifications);
  };

  var open = function open(args, closeCallback) {
    var extendedArgs = (0, _extends2.default)({}, args, {
      maxWidth: getContainerWidth()
    });
    var notif = new Notification(extendedArgs);
    notif.args = extendedArgs; // If we have a timeout value

    if (extendedArgs.timeout > 0) {
      notif.timer = setTimeout(function () {
        notif.close();
        closeCallback();
      }, extendedArgs.timeout);
    }

    notif.on('close', function () {
      closeCallback();
    });
    notif.renderTo();
    return notif;
  };

  var close = function close(notification) {
    notification.close();
  };

  var getArgs = function getArgs(notification) {
    return notification.args;
  };

  return {
    open: open,
    close: close,
    reposition: reposition,
    getArgs: getArgs
  };
}

module.exports = exports.default;